import { RouterDataLinks } from '@campaign-portal/components-library';
import { AuthGuard, AuthGuardChild } from '../../auth/auth.guard';
import { SettingsComponent } from '../../pages/settings/settings/settings.component';
import { EmptyContainerComponent } from '../../layouts/empty-container.component';
import { EditSourceComponent } from '../../pages/sources/edit-source/edit-source.component';
import { SourcesComponent } from '../../pages/sources/sources.component';
import { CamaraRulesComponent } from '../../pages/camara-rules/camara-rules.component'; // добавлен импорт
import { EditAiRulesComponent } from 'src/app/pages/ai-rules/edit-ai-rules/edit-ai-rules.component';

export const routerLinks: Readonly<RouterDataLinks> = {
	clients: {
		canActivate: [AuthGuard],
		path: 'clients',
		loadComponent: () => import('../../pages/clients/clients.component').then((m) => m.ClientsComponent),
		data: {
			permissions: ['clients.read'],
			title: 'clients.title',
			icon: 'ds-icons/raw-svg/icon-case-24',
			animationState: 'ClientsComponent',
		},
	},
	sources: {
		canActivate: [AuthGuard],
		path: 'sources',
		component: EmptyContainerComponent,
		data: {
			permissions: ['sources.read'],
			title: 'sources.title',
			icon: 'ds-icons/raw-svg/icon-source-24',
			animationState: 'SourcesComponent',
		},
		children: [
			{
				canActivate: [AuthGuard],
				path: '',
				component: SourcesComponent,
				data: {
					permissions: ['sources.read'],
					title: 'sources.title',
					icon: 'show_chart',
					animationState: 'SourcesComponent',
					hiddenMenu: true,
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'new',
				component: EditSourceComponent,
				data: {
					permissions: ['sources.edit'],
					title: 'sources.new',
					icon: 'show_chart',
					animationState: 'EditSourceComponent',
					hiddenMenu: true,
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'edit/:id',
				component: EditSourceComponent,
				data: {
					permissions: ['sources.edit'],
					title: 'sources.edit',
					icon: 'show_chart',
					animationState: 'EditSourceComponent',
					hiddenMenu: true,
					backRoute: true,
				},
			},
		],
	},
	import_rates: {
		canActivate: [AuthGuard],
		path: 'import_rates',
		loadComponent: () => import('../../pages/import rates/import-rates.component').then((m) => m.ImportRatesComponent),
		data: {
			permissions: ['import_rates.read'],
			title: 'import_rates.title',
			icon: 'ds-icons/raw-svg/icon-lightning-24',
			animationState: 'ImportRatesComponent',
		},
	},
	reference_books: {
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuardChild],
		path: 'reference_books',
		component: EmptyContainerComponent,
		data: {
			permissions: [],
			title: 'gl.reference_books',
			icon: 'ds-icons/raw-svg/icon-book-24',
			animationState: 'CurrenciesComponent',
		},
		children: [
			{
				canActivate: [AuthGuard],
				path: 'currencies',
				loadComponent: () =>
					import('../../pages/settings/currencies/currencies.component').then((m) => m.CurrenciesComponent),
				data: {
					permissions: ['currencies.read'],
					title: 'currencies.title',
					animationState: 'CurrenciesComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'rates',
				loadComponent: () => import('../../pages/settings/rates/rates.component').then((m) => m.RatesComponent),
				data: {
					permissions: ['rates.read'],
					title: 'rates.title',
					animationState: 'RatesComponent',
				},
			},
		],
	},
	dipping: {
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuardChild],
		path: 'dipping',
		component: EmptyContainerComponent,
		data: {
			permissions: [],
			title: 'gl.dipping',
			icon: 'ds-icons/raw-svg/icon-note-24',
			animationState: 'RulesComponent',
		},
		children: [
			{
				canActivate: [AuthGuard],
				path: 'rules',
				loadComponent: () => import('../../pages/rules/rules.component').then((m) => m.RulesComponent),
				data: {
					permissions: ['rules.read'],
					title: 'rules.title',
					animationState: 'RulesComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'camara_rules',
				component: CamaraRulesComponent,
				data: {
					permissions: ['camara_rules.read'],
					title: 'camara_rules.title',
					animationState: 'CamaraRulesComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'response_code_translations',
				loadComponent: () =>
					import('../../pages/response-code-translations/response-code-translations.component').then(
						(m) => m.ResponseCodeTranslationsComponent
					),
				data: {
					permissions: ['system_codes.read', 'translation_rules.read'],
					title: 'response_code_translations.title',
					animationState: 'ResponseCodeTranslationsComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'direct_dipping',
				loadComponent: () =>
					import('../../pages/manual-dipping/manual-dipping.component').then((m) => m.ManualDippingComponent),
				data: {
					permissions: ['mdtask.read'],
					title: 'manual_dipping.title',
					animationState: 'ManualDippingComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'simulation',
				loadComponent: () => import('../../pages/simulation/simulation.component').then((m) => m.SimulationComponent),
				data: {
					permissions: ['simulations.read'],
					title: 'simulation.title',
					animationState: 'SimulationComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'ai_rules',
				component: EmptyContainerComponent,
				data: {
					permissions: ['ai_rules.read'],
					title: 'ai_rules.title',
					animationState: 'AiRulesComponent',
				},
				children: [
					{
						canActivate: [AuthGuard],
						path: '',
						loadComponent: () => import('../../pages/ai-rules/ai-rules.component').then((m) => m.AiRulesComponent),
						data: {
							permissions: ['ai_rules.read'],
							title: 'ai_rules.title',
							animationState: 'AiRulesComponent',
							hiddenMenu: true,
						},
					},
					{
						canActivate: [AuthGuard],
						path: 'new',
						component: EditAiRulesComponent,
						data: {
							permissions: ['ai_rules.edit'],
							title: 'ai_rules.new',
							animationState: 'EditAiRulesComponent',
							hiddenMenu: true,
						},
					},
					{
						canActivate: [AuthGuard],
						path: 'edit/:id',
						component: EditAiRulesComponent,
						data: {
							permissions: ['ai_rules.edit'],
							title: 'ai_rules.edit',
							animationState: 'EditAiRulesComponent',
							hiddenMenu: true,
							backRoute: true,
						},
					},
				],
			},
		],
	},
	administration: {
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuardChild],
		path: 'administration',
		component: EmptyContainerComponent,
		data: {
			permissions: [],
			title: 'gl.administration',
			icon: 'ds-icons/raw-svg/icon-person-circle-24',
			animationState: 'CurrenciesComponent',
		},
		children: [
			{
				canActivate: [AuthGuard],
				path: 'users',
				loadComponent: () => import('../../pages/users/users.component').then((m) => m.UsersComponent),
				data: {
					permissions: ['users.read'],
					title: 'users_roles.users.title',
					animationState: 'UsersComponent',
				},
			},
			{
				canActivate: [AuthGuard],
				path: 'roles',
				component: EmptyContainerComponent,
				data: {
					permissions: ['roles.read'],
					title: 'users_roles.roles.title',
					animationState: 'RolesComponent',
				},
				children: [
					{
						canActivate: [AuthGuard],
						path: '',
						loadComponent: () => import('../../pages/roles/roles.component').then((m) => m.RolesComponent),
						data: {
							permissions: ['roles.read'],
							title: 'users_roles.roles.title',
							animationState: 'RolesComponent',
							hiddenMenu: true,
						},
					},
					{
						canActivate: [AuthGuard],
						path: 'new',
						loadComponent: () =>
							import('../../pages/roles/edit-role/edit-role.component').then((m) => m.EditRoleComponent),
						data: {
							permissions: ['roles.edit'],
							title: 'users_roles.roles.create',
							icon: 'show_chart',
							animationState: 'EditRoleComponent',
							hiddenMenu: true,
							backRoute: true,
						},
					},
					{
						canActivate: [AuthGuard],
						path: 'edit/:id',
						loadComponent: () =>
							import('../../pages/roles/edit-role/edit-role.component').then((m) => m.EditRoleComponent),
						data: {
							permissions: ['roles.edit'],
							title: 'users_roles.roles.edit',
							icon: 'show_chart',
							animationState: 'EditRoleComponent',
							hiddenMenu: true,
							backRoute: true,
						},
					},
				],
			},
			{
				canActivate: [AuthGuard],
				path: 'history-logs',
				loadComponent: () =>
					import('../../pages/history-logs/history-logs.component').then((m) => m.HistoryLogsComponent),
				data: {
					permissions: ['history_logs.read'],
					title: 'history_logs.title',
					animationState: 'HistoryLogsComponent',
				},
			},
		],
	},
	settings: {
		canActivate: [AuthGuard],
		path: 'settings',
		component: SettingsComponent,
		data: {
			permissions: ['settings.read', 'settings.edit'],
			title: 'settings.title',
			icon: 'ds-icons/raw-svg/icon-settings-24',
			animationState: 'SettingsComponent',
		},
	},
	// hidden
	profile: {
		canActivate: [AuthGuard],
		path: 'profile',
		loadComponent: () => import('../../pages/profile/profile.component').then((m) => m.ProfileComponent),
		data: {
			permissions: ['profile.edit'],
			title: 'users_roles.users.profile',
			icon: 'account_circle',
			animationState: 'ProfileComponent',
			hiddenMenu: true,
		},
	},
	direct_dipping_results: {
		canActivate: [AuthGuard],
		path: 'direct_dipping_results/:id',
		loadComponent: () =>
			// eslint-disable-next-line max-len
			import('../../pages/manual-dipping/manual-dipping-view-results/manual-dipping-view-results.component').then(
				(m) => m.ManualDippingViewResultsComponent
			),
		data: {
			permissions: ['mdtask.read'],
			title: 'manual_dipping.title',
			icon: 'icon-paper-plane-tilt',
			animationState: 'ManualDippingViewResultsComponent',
			hiddenMenu: true,
			backRoute: true,
		},
	},
};
